import { baseUrl, passportApiUrl,passportUrl } from "@/utils/config";
import Axios from "@/plugins/axios";
/**
 * 获取主工艺
 */
export const listMainCategory = () => {
  const config = {
    url: `${passportUrl}/common/dict/list-main-category`,
    method: "GET",
  };
  return Axios(config);
};
/**
 * 获取服务商类型数据
 */
export const listServerType = () => {
  const config = {
    url: `${passportUrl}/common/dict/list-server-type`,
    method: "GET",
  };
  return Axios(config);
};
/**
 * 获取国家列表
 */

export const getCountryList = () => {
  const config = {
    url: `${passportUrl}/common/dict/country-list`,
    method: "GET",
  };
  return Axios(config);
};
/**
 * 根据国家查询省份信息
 */

export const getProvinceList = (params) => {
  const config = {
    url: `${passportUrl}/common/dict/province-list`,
    method: "POST",
    data: params,
  };
  return Axios(config);
};
/**
 * 根据省份查询城市信息
 */

export const getCityList = (params) => {
  const config = {
    url: `${passportUrl}/common/dict/city-list`,
    method: "POST",
    data: params,
  };
  return Axios(config);
};
/**
 *  创建企业
 */

export const CreateUserCompany = (params) => {
  const config = {
    url: `${passportUrl}/user/create-multiuser`,
    method: "POST",
    data: params,
  };
  return Axios(config);
};
/**
 *  获取当前账号下绑定的企业列表
 */

export const getCompanyList = (params) => {
  const config = {
    url: `${passportUrl}/user/login-list`,
    method: "GET",
    params: params,
  };
  return Axios(config);
};
/**
 *  切换当前账号下绑定的企业
 */

export const cutCompany = (params) => {
  const config = {
    url: `${passportUrl}/user/run-as`,
    method: "POST",
    data: params,
  };
  return Axios(config);
};
/**
 *  退出登录
 */

export const userLogout = () => {
  const config = {
    url: `${passportUrl}/user/logout`,
    method: "POST",
  };
  return Axios(config);
};
/**
 *  账号安全 发送邮箱验证码
 */

export const getAccountEmailCode = (data) => {
  const config = {
    url: `${passportUrl}/account-security/send-email-code`,
    method: "POST",
    data,
  };
  return Axios(config);
};

/**
 *  账号安全 验证码校验-安全验证
 */

export const getAccountValidateSecurity = (data, params) => {
  const config = {
    url: `${passportUrl}/account-security/validate-security`,
    method: "POST",
    data,
    params,
  };
  return Axios(config);
};

/**
 *  账号安全 发送手机验证码-返回剩余时间
 */

export const getAccountMobileCode = (data) => {
  const config = {
    url: `${passportUrl}/account-security/send-mobile-code`,
    method: "POST",
    data,
  };
  return Axios(config);
};

/**
 *  账号安全 获取信息
 */

export const getUserSecurityInfo = () => {
  const config = {
    url: `${passportUrl}/account-security/query-user-security-info`,
    method: "GET",
  };
  return Axios(config);
};